import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'seduo-ui';
export default class Example extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
        };
    }
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
    render() {
        return (<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle>Dropdown</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem header>Header</DropdownItem>
                    <DropdownItem disabled>Action</DropdownItem>
                    <DropdownItem>Another Action</DropdownItem>
                    <DropdownItem divider/>
                    <DropdownItem>Another Action</DropdownItem>
                </DropdownMenu>
            </Dropdown>);
    }
}
